<template>
    <section class="page-content">
        <TopBackgroundComponent/>
        <LinkTopComponent/>
        <!-- <LinkBottomComponent/> -->
    </section>
</template>

<script setup>
    import TopBackgroundComponent from '../components/TopBackgroundComponent.vue';
    import LinkTopComponent from '@/components/link/LinkTopComponent.vue';
    // import LinkBottomComponent from '@/components/link/LinkBottomComponent.vue';
    window.scrollTo(0, 0);
</script>

<style scoped>
    /*  */
</style>